<template>
    <div>
      <div class="card-title h5">5. {{ $t('tabs.expectations.description') }}</div>
        <div class="col-sm-12 col-md-offset-1 col-md-10">

        <div class="form-group">
          <label class="required form-label">{{ $t('tabs.expectations.question1') }}</label>

          <table class="table table-sttriped">
            <tbody><tr>
              <th></th>
              <th v-for="ponderacio in 5" :key="ponderacio">{{ ponderacio }}</th>
            </tr>
            <tr v-for="(pregunta, index) in options_expectatives" :key="index">
              <th>{{ pregunta[lang] }}</th>
              <td v-for="ponderacio in 5" :key="ponderacio">
                  <input type="radio" class="form-check-input" :class="{'input': true, 'is-invalid': errors.has('expectatives_' + pregunta.id) }"
                         :name="'expectatives_' + pregunta.id"
                         :value="ponderacio"
                         v-validate="'required|included:1,2,3,4,5'"
                         v-model="expectatives[pregunta.id]"
                  >
              </td>
            </tr>
            <tr v-show="errors.length > 0">
              <td colspan="6"><span class="my-invalid-feedback">{{ $t('tabs.expectations.errors.missing_answers') }}</span></td>
            </tr>
            </tbody>
          </table>
        </div>
    </div>
                    
    </div>
</template>

<script>
import {list_expectatives} from "@/helpers/data";

export default {
    name: 'expectatives-i-opinio',
  props: { lang: { required:true, default:'ca'} },
  data() {
    return {
      expectatives: [],
      options_expectatives: list_expectatives
    }
  },
  created() {
    this.$validator.localize(this.lang);
  },
  methods: {
    async validate() {
      const result = await this.$validator.validateAll();
      if (!result) {
        return false;
      }
      this.$emit('on-validate', this.$data, true);
      return result;
    }
  }
}
</script>